export default "__VITE_PUBLIC_ASSET__23078b7a__"